import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=96b439dc&scoped=true&"
import script from "./projectAdd.vue?vue&type=script&lang=js&"
export * from "./projectAdd.vue?vue&type=script&lang=js&"
import style0 from "./projectAdd.vue?vue&type=style&index=0&id=96b439dc&scoped=true&lang=css&"
import style1 from "./projectAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b439dc",
  null
  
)

export default component.exports